import React, { PureComponent } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

import moment from "moment";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Colors from "../../constants/Colors";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Paper, Checkbox } from "@material-ui/core";
import {
  changeCoffeeSettings,
  getCoffeeSettingsRequest,
  modifyCoffeeSettingsRequest
} from "../../services/randomCoffee/actions";
import "moment/locale/fr";
moment.locale("fr");

const styles = theme => ({
  main: {
    width: "90%",
    marginTop: 15,
    flexDirection: "row",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start"
  },
  root: {
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    marginBottom: 15
  },
  leftSide: {
    width: "45%",
    minHeight: 700,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    display: "flex"
  },
  rightSide: {
    width: "45%",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column",
    display: "flex",
    position: "relative",
    minHeight: 800
    // flex: 1
  },
  container: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: 15,
    flex: 1,
    flexDirection: "row",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between"
  },
  saveButton: {
    marginTop: 15
  },
  title: {
    fontWeight: 500,
    marginTop: 15,
    marginBottom: 15
  },
  appTitleDiv: {
    width: 280,
    backgroundColor: Colors.mediumGreen,
    padding: 15,
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    borderRadius: 8,
    wordWrap: "break-word"
    // wordWrap: "break-word"
    // maxWidth: 280
  },
  appText: {
    minWidth: "1%",
    textAlign: "center",
    wordWrap: "break-word"
  },
  separator: {
    height: 1,
    marginTop: 5,
    marginBottom: 10,
    width: "45%",
    backgroundColor: Colors.mediumGrey
  },
  separatorContainer: {
    marginTop: 15,
    width: 280,
    display: "flex",
    flexWrap: "wrap",
    wordBreak: "break-all",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column"
  },
  content: {
    width: 280,
    marginTop: 80,
    wordWrap: "break-word",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column"
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  },
  paper: {
    alignItems: "center",
    justifyContent: "flex-start",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minHeight: 600
  },
  activateDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "row"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  },
  bold: {
    fontWeight: "bold"
  },
  notifText: {
    marginTop: 10,
    marginBottom: 10
  }
});

class Creation extends PureComponent {
  state = {
    expanded: null,
    labelWidth: 0
  };

  componentDidMount() {
    this.props.getCoffeeSettingsRequest(this.props.clientId);
  }

  onSubmit = () => {
    const { reminderTime, activated, clientId } = this.props;
    this.props.modifyCoffeeSettingsRequest({
      clientId,
      reminderTime,
      activated
    });
    // this.props.createActionRequest({ how, title, why, clientId, category });
  };

  activate = () => {
    this.props.changeCoffeeSettings({ activated: !this.props.activated });
  };

  onChangeDay = event => {
    const isoWeekday = Number(event.target.value);
    const reminderTime = moment(this.props.reminderTime).isoWeekday(isoWeekday);
    this.props.changeCoffeeSettings({ reminderTime });
  };

  onChangeTime = event => {
    const time = event.target.value;
    const minute = Number(time.split(":")[1]);
    const hour = Number(time.split(":")[0]);

    const reminderTime = moment(this.props.reminderTime)
      .minute(minute)
      .hour(hour);
    this.props.changeCoffeeSettings({ reminderTime });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.main}>
        <div className={classes.paper}>
          <div>
            <div className={classes.activateDiv}>
              <Checkbox
                checked={this.props.activated}
                onChange={this.activate}
              />
              <Typography className={classes.bold}>
                Activer le Random Coffee
              </Typography>
            </div>
            <div className={classes.timeDiv}>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="age-native-simple">Jour</InputLabel>
                <Select
                  native
                  value={moment(this.props.reminderTime).isoWeekday()}
                  onChange={this.onChangeDay}
                  inputProps={{
                    name: "age",
                    id: "age-native-simple"
                  }}
                >
                  <option value={1}>Lundi</option>
                  <option value={2}>Mardi</option>
                  <option value={3}>Mercredi</option>
                  <option value={4}>Jeudi</option>
                  <option value={5}>Vendredi</option>
                </Select>
              </FormControl>
              <FormControl className={classes.formControl}>
                <TextField
                  id="time"
                  label="Horaire"
                  type="time"
                  onChange={this.onChangeTime}
                  value={moment(this.props.reminderTime).format("HH:mm")}
                  // defaultValue={moment(this.props.reminderTime).format("HH:mm")}
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{
                    step: 300 // 5 min
                  }}
                />
              </FormControl>
            </div>
          </div>
          <Typography className={classes.notifText}>
            {`Les participants recevront une notification de rappel et
            découvriront leur rencontre de la semaine tous les ${moment(
              this.props.reminderTime
            )
              .locale("fr")
              .format("dddd")} à ${moment(this.props.reminderTime).format(
              "HH:mm"
            )}`}
          </Typography>
          {this.props.requesting ? (
            <CircularProgress />
          ) : (
            <Button onClick={this.onSubmit} variant="contained" color="primary">
              Sauvegarder les changements
            </Button>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { requesting, reminderTime, activated } = state.randomCoffee;
  const { clientId } = state.client;
  return {
    token: state.auth.token,
    requesting,
    clientId,
    activated,
    reminderTime
  };
};

export default connect(
  mapStateToProps,
  {
    changeCoffeeSettings,
    getCoffeeSettingsRequest,
    modifyCoffeeSettingsRequest
  }
)(withStyles(styles)(Creation));
